export enum ContactFormReason {
  PERSON = 1,
  ORGANISATION = 2,
  PIDZ = 3,
}
export const enum ContactFormType {
  MESSAGE = 1,
  COMPLAINT = 2,
}